export default [

     {
          path: '/hierarchy',
          name: 'Hierarchy',
          component: () => import("@/views/Page/Hierarchy/Hierarchy.vue"),
           meta: {
               title: 'Hierarchy',
          },
     }
];